import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

export const Hero = ({ translations, isDark }) => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="home" className={`min-h-screen flex items-center justify-center pt-20 transition-colors duration-300 ${isDark ? 'bg-zinc-900' : 'bg-zinc-50'
      }`}>
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid grid-cols-12 gap-8 items-center">
          <div className="col-span-12 lg:col-span-7 lg:min-w-percent pb-[15dvh] md:pb-0 pt-[2dvh] md:pt-0">
            <div className="space-y-8">
              <div className="space-y-4">
                <div className={`inline-block border-2 px-4 py-2 ${isDark ? 'border-cyan-400' : 'border-cyan-500'
                  }`}>
                  <span className={`text-sm uppercase tracking-widest font-mono ${isDark ? 'text-cyan-400' : 'text-cyan-600'
                    }`}>IT Solutions</span>
                </div>
                <h1 className={`text-7xl md:text-8xl lg:text-9xl font-black leading-none tracking-tighter ${isDark ? 'text-white' : 'text-zinc-900'
                  }`}>
                  {translations.hero.title}
                </h1>
                <div className={`h-1 w-32 ${isDark ? 'bg-cyan-400' : 'bg-cyan-500'}`}></div>
              </div>

              <h2 className={`text-2xl md:text-3xl font-light ${isDark ? 'text-zinc-400' : 'text-zinc-700'
                }`}>
                {translations.hero.subtitle}
              </h2>

              <p className={`text-lg max-w-xl ${isDark ? 'text-zinc-500' : 'text-zinc-600'
                }`}>
                {translations.hero.description}
              </p>

              <div className="pt-4">
                <Button
                  onClick={scrollToContact}
                  size="lg"
                  className={`font-bold uppercase tracking-wider transition-all duration-200 group ${isDark
                    ? 'bg-cyan-400 text-black hover:bg-cyan-300'
                    : 'bg-cyan-500 text-white hover:bg-cyan-600'
                    }`}
                >
                  {translations.hero.cta}
                  <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </Button>
              </div>
            </div>
          </div>

          <div className="col-span-12 lg:col-span-5">
            <div className="relative">
              <div className={`min-h-[45dvh] max-h-[50dvh] aspect-square border-4 relative overflow-hidden ${isDark ? 'border-zinc-800 bg-zinc-750/50' : 'border-zinc-300 bg-zinc-100/50'
                }`}>
                <div className={`absolute inset-0 bg-gradient-to-br `}></div>
                <div className={`absolute top-0 right-0 w-20 h-20 xl:h-32 xl:w-32 border-l-4 border-b-4 ${isDark ? 'border-cyan-400' : 'border-cyan-500'
                  }`}></div>
                <div className={`absolute bottom-0 left-0 w-20 h-20 xl:h-32 xl:w-32 border-r-4 border-t-4 ${isDark ? 'border-cyan-400' : 'border-cyan-500'
                  }`}></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="text-center space-y-4">
                    <div className={`font-mono text-6xl font-bold ${isDark ? 'text-cyan-400' : 'text-cyan-600'
                      }`}>{'<AS/>'}</div>
                    <div className={`text-sm uppercase tracking-widest ${isDark ? 'text-zinc-600' : 'text-zinc-400'
                      }`}>Tech Solutions</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};